<template>
    <div class="register-container">
        <van-nav-bar title="Register" left-arrow @click-left="back"></van-nav-bar>

        <Banner />

        <!-- 基础信息 -->
        <template v-if="currentStep === 1">
            <van-form validate-first @submit="onFormNext" label-width="60px" class="form" ref="formRef">
                <div v-for="(item,index) in formAttr" :key="index">
                    <component v-if="item.display" :is="createComponent(item)" v-model="formData[item.name == 'username' ? 'name' : item.name]" :attr="item" />
                </div>
            </van-form>
        </template>

        <!-- 提交 -->
        <div class="submit">
            <van-button block round type="info" class="btn" :disabled="isClicked" :style="primaryBg" @click="OnSubmit()">Submit</van-button>
        </div>

    </div>
</template>

<script>
import Toast from 'vant/lib/toast';
import httpRequest from '@/module_visitor/api/http.js';
import { mapGetters } from 'vuex';
import Banner from '@/components/Common/banner';
import areaList from '@/utils/area';
import QBlank from '@/components/FormItem/DefaultInput';
import QRadio from '@/components/FormItem/QRadio';
import QCheck from '@/components/FormItem/QCheck';
import QAvatar from '@/components/FormItem/QAvatar';
import QArea from '@/components/FormItem/QArea';
import QTime from '@/components/FormItem/QTime';
import QImage from '@/components/FormItem/QImage';
export default {
    data() {
        return {
            areaList: areaList,
            formAttr: [],
            RemarkCheckList: [],
            RegSourceList: [],
            currentStep: 1,
            agreementShow: false,
            configData: {},
            formData: {
                RegSource: '',
                Company: '',
                Position: '',
                Name: '',
                IdCard: '',
                Tel: this.$route.query.tel,
                TeamId: this.$route.query.teamId,
                CompanyId: this.$route.query.companyId,
                Email: '',
                Identitys: '1',
                Remark: null,
                Address: '',
                Area: '',
                HealthyImg: '',
                SignCount: 0,
                IdCardType: '外商证',
                Remark: '',
                InviteId: this.$route.query.source,
            },
            areaShow: false,
            questionList: [],
            answersList: [],
            isClicked: false,
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
        primaryBg() {
            return { background: this.defaultInfo.config.primaryColor };
        },
        primaryColor() {
            return { color: this.defaultInfo.config.primaryColor };
        },
    },
    created() {
        const { config } = this.defaultInfo;
        if (config.formAttr) {
            var json2 = eval('(' + config.formAttr + ')');
            const json3 = json2.en.sort((a, b) => a.sort - b.sort);
            this.formAttr = json3;
        }

        this.configData = config;
        this.formData.companyShareId = this.$route.query.companyShareId;
        this.formData.teamId = this.$route.query.teamId;
        this.formData.companyId = this.$route.query.companyId;
        this.formData.tel = this.$route.query.tel;
        this.formData.email = this.$route.query.email;
        this.formData.inviteId = this.$route.query.source;
    },

    mounted() {
        const { config } = this.defaultInfo;

        var primaryColor = document.querySelectorAll('.primary-color');
        primaryColor.forEach(item => {
            item.setAttribute('style', `color:${config.primaryColor}`);
        });
        var primaryBorderColor = document.querySelectorAll('.primary-border-color');
        primaryBorderColor.forEach(item => {
            item.setAttribute('style', `border-color:${config.primaryColor}`);
        });
        var primaryBg = document.querySelectorAll('.primary-bg');

        primaryBg.forEach(item => {
            item.setAttribute('style', `background:${config.primaryColor}`);
        });
    },
    components: {
        Banner,
        QBlank,
        QRadio,
        QCheck,
        QAvatar,
        QArea,
        QTime,
        QImage,
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        createComponent(item) {
            return item.type;
        },
        // 注册
        handleRegister(model) {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            this.isClicked = true;
            httpRequest
                .post(`/api/visitor/register`, model)
                .then(res => {
                    const { code, data, msg } = res.data;
                    if (code == 200) {
                        Toast('登记成功');
                        window.localStorage.setItem('v_token', data);
                        this.$router.push({ path: '/' });
                    } else {
                        Toast(msg);
                    }
                })
                .catch(error => {})
                .finally(() => {
                    this.isClicked = false;
                    Toast.clear();
                });
        },

        OnSubmit() {
            this.$refs.formRef
                .validate()
                .then(() => {
                    this.params = {
                        ...this.formData,
                        answers: this.answersList,
                    };

                    this.handleRegister(this.params);
                })
                .catch(err => {
                    console.log('err', err);
                });
        },

        // 表单提交
        onFormNext(form) {},
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.register-container {
    width: 100%;
    min-height: 100%;
    .step-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 24px;
        .step-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &.active {
                .step-number {
                    background: var(--theme_bg_color);
                    color: #fff;
                }
                span {
                    color: var(--theme_primary_color);
                }
            }
            .step-number {
                width: 25px;
                height: 25px;
                line-height: 25px;
                background: #999;
                color: #fff;
                border-radius: 25px;
                text-align: center;
            }
            span {
                font-size: 14px;
                margin-top: 4px;
            }
        }
        .step-line {
            width: 100px;
            height: 1px;
            margin-bottom: 12px;
            border-bottom: 2px dotted var(--theme_primary_color);
        }
    }

    .form {
        padding: 20px;

        .form-border {
            background: #fff;
            padding: 5px;
            border: 1px solid #dbdbdb;
            border-radius: 10px;
            margin-top: 20px;
        }
        .form-item {
            background: #fff;
            // box-shadow: 2px 2px 10px 2px #dbdbdb;
            border: 1px solid #dbdbdb;
            border-radius: 10px;
            margin-top: 12px;
            display: flex;
            flex-direction: column;

            padding: 5px 0;
            .label {
                font-size: 14px;
                color: #646566;
                padding: 0 18px;
                position: relative;
                span {
                    color: $font_color;
                    margin: 0 0px 0 6px;
                }
            }

            .label-require::before {
                position: absolute;
                left: 8px;
                color: #ee0a24;
                font-size: 14px;
                content: '*';
            }
        }
        .form-title {
            font-size: 32px;
            position: relative;
            padding: 10px 32px;
            color: #323233;
            font-size: 14px;
            &::after {
                position: absolute;
                left: 8px;
                color: #ee0a24;
                font-size: 14px;
                content: '*';
            }
        }

        .form-require {
            position: relative;
            width: 10px;
        }
        .form-content {
            padding: 10px;
        }
    }

    //   声明
    .agree-txt {
        font-size: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #dbdbdb;

        height: 44px;
        .check {
            display: flex;
            align-items: center;
            font-weight: bold;
            & > div {
                margin-right: 8px;
            }
        }

        p {
            color: #ba0015;
        }
    }

    .popup-content {
        font-size: 32px;
        padding: 20px;
        .dialog-box {
            padding: 24px;

            p {
                padding: 4ex;
            }
        }
        h2 {
            text-align: center;
        }

        img {
            width: 100%;
        }

        p {
            text-indent: 40px;
            margin-top: 10px;
        }
    }

    .agree-btn {
        width: 300px;
        line-height: 30px;

        color: #fff;
        text-align: center;
        border-radius: 12px;
        margin: 10px auto;
        p {
        }
    }

    .submit {
        padding: 20px 40px 60px;
        display: flex;
        justify-content: space-between;
        .van-button {
            background: var(--theme_bg_color);
            color: #fff;
        }
    }

    .dialog {
        margin-bottom: 20px;
    }
}

.question {
    padding: 0 10px;
    background: #fff;
    margin: 0 10px;

    .question-list {
        background: #fff;
        padding: 8px 15px;
        border: 1px solid #dbdbdb;
        border-radius: 10px;
        margin-top: 20px;
        ::v-deep .van-radio {
            padding: 4px 0px;
        }
        .question-title {
            font-weight: 600;
            padding: 12px 0;
            i {
                color: #f00;
            }
        }

        .question-item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 4px 0;
        }
        .question-input {
            width: 100%;
            outline: none;
            border: none;
            border: 1px solid #eaeaea;
        }
    }
}
</style>
